// extracted by mini-css-extract-plugin
export default {"wrapper":"LanguagesDialog_wrapper_cb225","language":"LanguagesDialog_language_b8f7f","error":"LanguagesDialog_error_e57f5"};